import { call, put, all, takeLatest, delay } from 'redux-saga/effects';
import { saveAs } from 'file-saver';
import moment from 'moment';

import i18n from 'app/i18n';
import { handleError, startLoading, finishLoading } from 'ducks/app/actions';
import * as actionTypes from './actionTypes';
import * as actions from './actions';
import * as services from './services';

// stores reply asynchronously over RabbitMQ, give online AIS installations
// a few seconds to answer before refreshing the list
const VERSION_REPORT_WAIT_MS = 8000;

function* fetchAisVersionList() {
  try {
    yield put(startLoading());
    const data = yield call(services.fetchAisVersionList);
    yield put(actions.fetchAisVersionListSuccess(data));
  } catch (e) {
    yield put(handleError(e));
  } finally {
    yield put(finishLoading());
  }
}

function* checkAisVersions() {
  try {
    yield put(startLoading());
    yield call(services.checkAisVersions);
    yield delay(VERSION_REPORT_WAIT_MS);
    const data = yield call(services.fetchAisVersionList);
    yield put(actions.fetchAisVersionListSuccess(data));
  } catch (e) {
    yield put(handleError(e));
  } finally {
    yield put(finishLoading());
  }
}

function* exportAisVersions() {
  try {
    yield put(startLoading());
    const { data } = yield call(services.exportAisVersions, i18n.language);
    const blob = new Blob([new Uint8Array(data)], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    yield call(saveAs, blob, `ais-versions-${moment().format('YYYY-MM-DD')}.xlsx`);
    yield put(actions.exportAisVersionsSuccess());
  } catch (e) {
    yield put(actions.exportAisVersionsFailure(e));
    yield put(handleError(e));
  }
  yield put(finishLoading());
}

export default function* () {
  yield all([
    yield takeLatest(actionTypes.FETCH_AIS_VERSION_LIST, fetchAisVersionList),
    yield takeLatest(actionTypes.CHECK_AIS_VERSIONS, checkAisVersions),
    yield takeLatest(actionTypes.EXPORT_AIS_VERSIONS, exportAisVersions),
  ]);
}
